<h1 matDialogTitle>{{ data.title }}</h1>
<mat-dialog-content>
  <p>{{ data.message }}</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>Schließen</button>
</mat-dialog-actions>
